import { AddRoomFormComponent } from './add-room-form';
import { AssignRoomContentToRoomComponent } from './assign-room-content';

export * from './add-room-form';
export * from './assign-room-content';

export const RoomOrganisms = [
    AddRoomFormComponent,
    AssignRoomContentToRoomComponent,
]